module.exports = __webpack_public_path__ + "static/media/admin.7ea5c951.png";